import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CatalogItem, CatalogItemChanged, ConnectivityCatalogType } from 'src/app/domains/connectivity/models/connectivity.model';

@Component({
  selector: 'gdp-connectivity-entry-form',
  templateUrl: './connectivity-entry-form.component.html',
  styleUrls: ['./connectivity-entry-form.component.scss']
})
export class ConnectivityEntryFormComponent implements OnInit {

  @Input() data: CatalogItem;
  @Output() valueChanges: EventEmitter<CatalogItemChanged> = new EventEmitter();

  public entryTypes: ConnectivityCatalogType[] = [ConnectivityCatalogType.modem_router, ConnectivityCatalogType.internet_key];

  public form: UntypedFormGroup;

  constructor() { }

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      brand: new UntypedFormControl(this.data?.brand || null, Validators.required),
      model: new UntypedFormControl(this.data?.model || null, Validators.required),
      type: new UntypedFormControl(this.data?.type || this.entryTypes[0])
    })

    this.valueChanges.emit({
      value: this.form.value,
      isValid: this.form.valid
    });

    this.form.valueChanges.subscribe((values) => {
      this.valueChanges.emit({
        value: values,
        isValid: this.form.valid
      });
    });
  }

  public onSelectType(type: ConnectivityCatalogType) {
    this.form.controls.type.setValue(type);
  }

}
